import { render, staticRenderFns } from "./discover.vue?vue&type=template&id=0a578730&scoped=true"
import script from "./discover.vue?vue&type=script&lang=js"
export * from "./discover.vue?vue&type=script&lang=js"
import style0 from "./discover.vue?vue&type=style&index=0&id=0a578730&prod&scoped=true&lang=scss"
import style1 from "./discover.vue?vue&type=style&index=1&id=0a578730&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a578730",
  null
  
)

export default component.exports